import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: theme.spacing(2),
      position: 'relative',
    },
    annotation: {},
    loader: {
      marginLeft: theme.spacing(2),
    },
  }),
  { name: 'MainAnnotations' }
);
